const MODULE_ID = 'news';
export default MODULE_ID;
